// Адаптация изображения картинки под мобилу
export function initSlideOwlCarousel (carouselId)
{
    $(BX(carouselId)).owlCarousel({
        loop : true, // Бесконечный скролл
        dots: false, // точки навигации
        nav: true, // Кнопки вперёд-назад
        margin: 10, // отступы по бокам
        lazyLoad: false,
        navText: ['<i class="icon-angle-left"></i>', '<i class="icon-angle-right"></i>'],
        responsive:{
            0:{
                items: 2
            },
            600:{
                items: 3
            },
            1000:{
                items: 5
            }
        }
    });
}

